import React from "react";
import {
  addAnswer,
  addNote,
  addWriteIn,
} from "../../../../redux/survey/actions";
import { makeStyles } from "@mui/styles";
import { Box, TextField, useMediaQuery, useTheme } from "@mui/material";
import { connect } from "react-redux";
import "rsuite/dist/styles/rsuite-default.css";
import "rsuite/dist/styles/rsuite-default.css";
import { useIntl } from "react-intl";
//  style for the text field component
const useStyles = makeStyles((theme) => ({
  textfield: {
    width: "100%",
    borderBlockColor: theme.palette.primary.light,
  },
  input1: {
    borderColor: theme.palette.primary.light,
    color: "black",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
}));

function NumberType(props) {
  const intl = useIntl();
  // Destructing  props for easy access to properties
  const { question, answeres, addAnswer_, isGreyOut, styles, hasError } = props;
  const theme = useTheme(); // Accessing the current theme
  const isMob = useMediaQuery(theme.breakpoints.down("sm")); // Check if device is mobile or not
  const classes = useStyles();

  // Function that handles onChange event of the TextField component
  const handleText = (text) => {
    // Regular expression to validate a number (with or without decimal)
    const numberRegex = /^[+-]?\d*\.?\d*$/;

    if (question?.allow_decimal && numberRegex.test(text.target.value)) {
      // Allow decimal point
      addAnswer_({
        id: question._id,
        value: text.target.value ? Number(text.target.value) : null,
        type: "text",
      });
    } else if (
      !question?.allow_decimal &&
      text.target.value &&
      Number.isInteger(parseFloat(text.target.value))
    ) {
      // Allow only integer if allow_decimal is false
      addAnswer_({
        id: question._id,
        value: text.target.value ? Number(text.target.value) : null,
        type: "text",
      });
    } else {
      // Add answer to Redux state
      addAnswer_({
        id: question._id,
        value: text.target.value ? Number(text.target.value) : null,
        type: "text",
      });
    }
  };

  let answer = answeres[question._id] ?? { value: "" }; // Extract the answer from answers by its ID

  return (
    <>
      <Box style={{ cursor: isGreyOut && "not-allowed" }}>
        <Box
          sx={{
            borderRadius: hasError ? "4px" : "8px",
            display: "inline-block",
            width: "100%",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: hasError
                ? "#ff4b4b !important"
                : "#DCE1EF !importent",
              borderWidth: hasError ? "2px !important" : undefined,
            },
          }}
        >
          <TextField
            disabled={isGreyOut}
            style={styles}
            className={classes.textfield}
            id="outlined-basic"
            value={answer?.value ?? ""}
            onChange={handleText}
            size={isMob ? "small" : "medium"}
            placeholder={
              question?.placeholderText ??
              intl.formatMessage({ id: "enter-digit" })
            }
            variant="outlined"
            error={hasError}
            FormHelperTextProps={{
              style: { display: "none" },
            }}
            InputProps={{
              classes: { input: classes.input1 },
              style: {
                color: "black",
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d32f2f !important",
                  borderWidth: "2px !important",
                },
                "&.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d32f2f !important",
                },
                "&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d32f2f !important",
                },
              },
            }}
            type="number"
          />
        </Box>
      </Box>
    </>
  );
}
// Function that extracts the necessary state from the Redux store
const mapStateToProps = (state) => {
  return {
    answeres: state.survey.answeres,
  };
};
// Function that binds the dispatch to action creators
const mapDispatchToProps = (dispatch) => {
  return {
    addAnswer_: (data) => dispatch(addAnswer(data)),
    addNote_: (data) => dispatch(addNote(data)),
    addWriteIn_: (data) => dispatch(addWriteIn(data)),
  };
};
// Connect Redux Store with this component
export default connect(mapStateToProps, mapDispatchToProps)(NumberType);
